module.exports = __webpack_public_path__ + "img/Pelotas para entrenamiento Paddel.c7df339d.jpg";